// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"M3-z","displaySixCardTiles":"N3-z"};